export default __webpack_public_path__ + "static/media/Explanation1.9bf6fe6f.JPEG";